// Handles the "Get in Touch" form submission.
// Writes the inquiry to Firestore in a `contactSubmissions` collection.
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from './firebase.js';

/**
 * @param {{ name: string, email: string, company?: string, budget?: string, message: string }} payload
 * @returns {Promise<{ id: string }>}
 */
export async function submitContactForm(payload) {
  if (!payload?.name || !payload?.email || !payload?.message) {
    throw new Error('Name, email, and message are required.');
  }

  const docRef = await addDoc(collection(db, 'contactSubmissions'), {
    name: payload.name,
    email: payload.email,
    company: payload.company ?? '',
    budget: payload.budget ?? '',
    message: payload.message,
    createdAt: serverTimestamp(),
  });

  return { id: docRef.id };
}
